import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

const ITEMS = [
  {
    icon: <VerifiedIcon />,
    title: 'Verified properties',
    body: 'Every hotel is enlisted and vetted by Dataman. No fake listings, no surprises at check-in.',
    accent: '#053C71',
  },
  {
    icon: <PriceCheckIcon />,
    title: 'Transparent pricing',
    body: 'Real-time rates with seasonal offers built in. The price you see is the price you pay.',
    accent: '#EB6F03',
  },
  {
    icon: <EventAvailableIcon />,
    title: 'Flexible bookings',
    body: 'Modify dates or guest count any time before check-in. Cancellation handled in-app.',
    accent: '#00A859',
  },
  {
    icon: <HeadsetMicIcon />,
    title: '24/7 support',
    body: 'Reach our team any hour of the day, in your language. We answer real travelers, fast.',
    accent: '#1F8DD6',
  },
];

export function OtaValueProps() {
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, bgcolor: 'background.paper' }}>
      <Container maxWidth="xl">
        <Stack spacing={1} sx={{ mb: { xs: 4, md: 6 }, textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="overline" color="secondary.main">
            Why book with OTA
          </Typography>
          <Typography variant="h3" sx={{ maxWidth: 720 }}>
            Built for travelers, backed by Dataman
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 560 }}>
            Four reasons travelers across India choose OTA over the noisy alternatives.
          </Typography>
        </Stack>

        <Grid container spacing={3}>
          {ITEMS.map((it) => (
            <Grid key={it.title} item xs={12} sm={6} md={3}>
              <Stack
                spacing={1.5}
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: 3,
                  border: 1,
                  borderColor: 'divider',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-3px)',
                    boxShadow: '0 12px 28px rgba(15, 23, 42, 0.10)',
                    borderColor: 'transparent',
                  },
                }}
              >
                <Box
                  sx={{
                    width: 52, height: 52, borderRadius: 2,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    bgcolor: `${it.accent}15`, color: it.accent,
                  }}
                >
                  {it.icon}
                </Box>
                <Typography variant="h6">{it.title}</Typography>
                <Typography variant="body2" color="text.secondary">{it.body}</Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
